import type { Form, Field } from '@jmvdevelop/svelte-form';

export function addFieldOrRootError<TValues, TFieldValue>(
    form: Form<TValues, string>,
    field: Field<TValues, TFieldValue> | undefined | null,
    error: string,
) {
    if (field == null) {
        return form.actions().addRootError(error);
    } else {
        return form.actions().addError(field, error);
    }
}
